var swatches_xz = document.querySelectorAll('.color-swatch');
for (var i = 0; i < swatches_xz.length; i++) {
  swatches_xz[i].addEventListener('click', function() {
    var value = this.getAttribute('data-value');
    // Guard: querySelector returns null when the swatch's data-value has no matching
    // hidden variant <input> in the DOM (e.g. unavailable / out-of-stock variant).
    var el = document.querySelector('[value="' + value + '"]');
    if (!el) {
      // No matching variant input — swatch click is a no-op.
      // Optionally add UX feedback here (e.g. visual "unavailable" indicator).
      return;
    }

    var variantId = el.getAttribute('data-variant-id');

    // Guard: variant input exists but is missing the data-variant-id attribute.
    if (!variantId) {
      return;
    }

    window.location.href = '/products/' + product.handle + '?variant=' + variantId;
  });
}